<template>
  <div class="mainPage">
    <div class="typeArea">
      <div class="firstWrap">
        <div v-for="(item,i) of tabList" :key="i" :class="$route.path.includes(item.route) ? 'activeFirst' : ''" @click="handleSelect(item.route)">
          {{ item.name }}
        </div>
      </div>
      <div>
        <!-- 主题内容 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocolTrans */
import { mapGetters } from 'vuex'
export default {
  name: 'MyAssetNew',
  data() {
    return {
      tabList: [
        {
          route: '/myAssetNew/mywithdrawNew',
          name: '出入金',
        },
        {
          route: '/myAssetNew/myBankInfo',
          name: '签约解约',
        },
        {
          route: '/myAssetNew/journalAccount',
          name: '查询资金流水',
        },
        {
          route: '/myAssetNew/allFund',
          name: '查询用户总资金',
        },
        {
          route: '/myAssetNew/flowFund',
          name: '查询出入金',
        },
        {
          route: '/myAssetNew/tranferNew',
          name: '资金划转',
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['isClickZjGetter'])
  },
  watch: {
    isClickZjGetter(val) {
      if (val) {
        this.handleSelect('/myAssetNew/mywithdrawNew')
        this.$store.commit('setIsClickZj', false)
      }
    }
  },
  mounted() {
    this.$store.commit('setIsClickZj', false)
    if (localStorage.getItem('isActive111')) {
      this.$router.push(localStorage.getItem('isActive111'))
    }
    this.searchFirmId1()
  },
  destroyed() {
    localStorage.setItem('isActive111', '')
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push(key)
      localStorage.setItem('isActive111', key)
    },
    searchFirmId1() {
      const userMes = this.$store.state.common.sessionInfo
      protocolTrans.param_firmIdSearch.param.userId = userMes.userId
      http.postFront(protocolTrans.param_firmIdSearch).then(response => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('FirmIdList_w', JSON.stringify(value))
        } else {
          this.$message(message)
        }
      })
    },
    goNext() {
      this.$refs.aggreementDialog.showDialog()
    }
  }
}
</script>